import createProtocolsPdf from './createProtocolsPdf';
import { createAthleteRecord } from '../common';
import DownloadsPicker from '../DownloadsPicker';
import FileDownload from '../../../components/FileDownload';

import React from 'react';
import { get, keyBy, mapValues, pick, sumBy } from 'lodash';

console.warn('FIXME: Consolidate with resultSelector');
const createProtocolRecords = (mode, protocols, meta) => {
  switch (mode) {
    default:
      return protocols.map(protocol => ({
        title: protocol.title,
        rows: protocol.athletes.map(athlete => {
          // TODO: Consolidate this code.
          const liftsById = keyBy(meta.orm.lifts, 'id');

          const isLiftFinal = mapValues(liftsById, lift => {
            const lastDeclaration = athlete.lastDeclarationByLiftId[lift.id];
            const lastAttempt = athlete.lastAttemptByLiftId[lift.id];
            return (
              lastDeclaration && // FIXME: This row differs to scoreboard.
              get(lastDeclaration, 'attemptNumber') ===
                get(lastAttempt, 'number')
            );
          });
          const isTotalFinal =
            meta.orm.lifts.every(lift => isLiftFinal[lift.id]) ||
            meta.orm.lifts.some(
              lift =>
                isLiftFinal[lift.id] && !athlete.bestAttemptByLiftId[lift.id],
            );
          const isTotalComplete = meta.orm.lifts.every(
            lift => athlete.bestAttemptByLiftId[lift.id],
          );
          const total = isTotalComplete
            ? sumBy(Object.values(athlete.bestAttemptByLiftId), 'weight')
            : 0;
          // TODO: Consolidate this code.

          return {
            athlete: createAthleteRecord(athlete.entry, meta),
            attemptsByLiftId: mapValues(athlete.attemptsByLiftId, attempts =>
              attempts.map(attempt =>
                pick(attempt, 'number', 'weight', 'decision.isGoodLift'),
              ),
            ),
            resultsByLiftId: mapValues(
              liftsById,
              lift =>
                isLiftFinal[lift.id]
                  ? get(athlete.bestAttemptByLiftId, [lift.id, 'weight'], 0)
                  : undefined,
            ),
            total: isTotalFinal ? total : undefined,
          };
        }),
      }));
  }
};

const ProtocolsDownload = ({ mode, protocols, meta, ...props }) => {
  const onFileContents = () => {
    return createProtocolsPdf(
      createProtocolRecords(mode, protocols, meta),
      meta,
    );
  };
  return (
    <FileDownload
      mimeType="appication/pdf"
      fileName={`protocols-${mode}.pdf`}
      onContents={onFileContents}
      {...props}
    />
  );
};

const ProtocolsDownloads = ({ protocols, meta }) => {
  const modes = mapValues(
    {
      all: 'All protocols',
      //template: 'Empty template',
      //...(process.env.NODE_ENV !== 'production' ? { test: 'Test list' } : {}),
    },
    (text, mode) => ({
      mode,
      text,
      download: (
        <ProtocolsDownload mode={mode} protocols={protocols} meta={meta} />
      ),
    }),
  );

  return <DownloadsPicker modes={modes} />;
};

export default ProtocolsDownloads;



// WEBPACK FOOTER //
// ./src/pages/Home/protocols/ProtocolsDownloads.js